import { createContext, useContext, useEffect, useState } from 'react';
import { data } from '../data';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        const saved = window.localStorage.getItem('nj-language');
        if (saved === 'en' || saved === 'es') return saved;
        return window.location.pathname.startsWith('/es/') ? 'es' : 'en';
    });

    useEffect(() => {
        window.localStorage.setItem('nj-language', language);
        document.documentElement.lang = language;
    }, [language]);

    // Función para obtener traducciones por sección
    const getTranslations = (section) => {
        return data[section][language] || data[section]['en'];
    };

    // Función para obtener todas las traducciones combinadas (compatibilidad)
    const getAllTranslations = () => {
        const allTranslations = {};

        Object.keys(data).forEach(section => {
            const sectionData = data[section][language] || data[section]['en'];
            Object.assign(allTranslations, sectionData);
        });

        return allTranslations;
    };

    const value = {
        language,
        setLanguage,
        getTranslations,
        // Mantener compatibilidad con el sistema anterior
        t: getAllTranslations()
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};
